import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';

const getRandomValue = (min, max) => Math.random() * (max - min) + min;
const getRandomColor = () => {
  const colors = ['bg-ih-red', 'bg-ih-blue', 'bg-ih-green', 'bg-ih-yellow', 'bg-ih-purple', 'bg-ih-orange'];
  return colors[Math.floor(Math.random() * colors.length)];
};

const FeuArtifice = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = Array.from({ length: 200 }).map((_, i) => ({
      id: i,
      x: getRandomValue(-500, 500),
      y: getRandomValue(-500, 500),
      size: getRandomValue(2, 10),
      delay: getRandomValue(0, 0.3),
      fadeOutDelay: getRandomValue(0.5, 1.5),
      color: getRandomColor(),
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className='flex justify-center items-center'>
      {particles.map(({ id, x, y, size, delay, fadeOutDelay, color }) => (
        <motion.div
          key={id}
          initial={{ opacity: 0, scale: 0.5, x: 0, y: 0 }}
          animate={{ opacity: [0, 1, 0], scale: [0.5, 1.2, 0.8], x, y }}
          transition={{
            duration: 1.5,
            delay,
            ease: "easeOut",
            opacity: { duration: fadeOutDelay }
          }}
          className={`absolute ${color} rounded-full`}
          style={{ width: size, height: size }}
        />
      ))}
    </div>
  );
};

export default FeuArtifice;
